import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  dialgoTitleContainer: { paddingBottom: '0' },
  dialogTitle: {
    color: '#000000',
    textAlign: 'center',
  },
  closeIconContainer: { alignSelf: 'flex-end' },
  closeIcon: { color: '#000000' },
  actionsContainer: {
    display: 'flex',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
  },
  selectInput: { padding: '10px', marginTop: '10px', fontSize: '0.875rem', color: '#000000' },
  transferList: {
    marginTop: 12,
    '& > *:not(:last-child)': {
      marginBottom: 12,
    },
  },
  transfersContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  transContainer: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 6,
    width: '100%',
    color: '#000000',
  },
  selecTransfer: {
    width: '100%',
  },
  gridTransfers: {
    color: '#000000',
    width: '100%',
  },
  totalContainer: {
    display: 'flex',
    gap: 10,
    justifyContent: 'end',
    width: '50%',
    paddingRight: 6,
    color: '#000000',
  },
}));
